
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ci-primary",attrs:{"fill":"#ccc","d":"M462.541 316.3l-64.344-42.1 24.774-45.418A79.124 79.124 0 00432.093 192v-72a103.941 103.941 0 00-174.609-76.477L279.232 67a71.989 71.989 0 01120.861 53v72a46.809 46.809 0 01-5.215 21.452L355.962 284.8l89.058 58.274a42.16 42.16 0 0119.073 35.421V432h-72v32h104v-85.506a74.061 74.061 0 00-33.552-62.194z"}}),_c('path',{staticClass:"ci-primary",attrs:{"fill":"#ccc","d":"M318.541 348.3l-64.343-42.1 24.773-45.418A79.124 79.124 0 00288.093 224v-72A104.212 104.212 0 00184.04 47.866C126.723 47.866 80.093 94.581 80.093 152v72a78 78 0 009.015 36.775l24.908 45.664L50.047 348.3A74.022 74.022 0 0016.5 410.4L16 496h336.093v-85.506a74.061 74.061 0 00-33.552-62.194zm1.552 115.7H48.186l.31-53.506a42.158 42.158 0 0119.073-35.421l88.682-58.029-39.051-71.592A46.838 46.838 0 01112.093 224v-72a72 72 0 11144 0v72a46.809 46.809 0 01-5.215 21.452L211.962 316.8l89.058 58.274a42.16 42.16 0 0119.073 35.421z"}})])
          )
        }
      }
    